import { useCallback, useState } from "react";
import DialogConfirmWrapper from "components/DialogConfirmWrapper";

const useConfirmation = ({ shouldConfirm = false, ...dialogProps }) => {
    const [pendingAction, setPendingAction] = useState(null);

    const withConfirmation = useCallback(
        (actionFn) =>
            (...args) => {
                if (shouldConfirm) {
                    setPendingAction(() => () => actionFn(...args));
                    return false;
                }

                return actionFn(...args);
            },
        [shouldConfirm]
    );

    const handleCancel = () => {
        setPendingAction(null);
    };

    const handleConfirm = () => {
        const action = pendingAction;
        setPendingAction(null);

        return action?.();
    };

    const confirmationDialog = (
        <DialogConfirmWrapper
            {...dialogProps}
            openPopup={pendingAction !== null}
            onClose={handleCancel}
            onConfirm={handleConfirm}
        />
    );

    return { withConfirmation, confirmationDialog };
};

export default useConfirmation;
